module.exports = __webpack_public_path__ + "static/media/deleteIcon.89788f5b.svg";